document.addEventListener('DOMContentLoaded', function () {

    const variantHandlingContainer = document.getElementById("variant-handling-days");
  
    if (!variantHandlingContainer) {
      return;
    }
  
    const variantInput = document.querySelector('input[name="id"]');
    function updateHandlingDays() {
      const selectedVariantId = variantInput.value;
      // console.log('Selected Variant ID:', selectedVariantId);
      const handlingSpan = document.querySelector(`#variant-handling-days .variant-handling[data-id="${selectedVariantId}"]`);
      // console.log("handlingSpan",handlingSpan);
      if (handlingSpan) {
        const handlingDays = handlingSpan.getAttribute("data-handling-days");
        
        const { weekday, monthDay } = getDeliveryDate(handlingDays || 1);
        document.getElementById('deliveryEstimate').innerHTML = `
          Ships by: <span class="delivery-weekday">${weekday}</span>, <span class="delivery-date">${monthDay}</span>
        `;
      } 
    }
    
  
    // Observe changes to the hidden input field
    const observer = new MutationObserver(updateHandlingDays);
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  
   
    updateHandlingDays();
  
    function getDeliveryDate(handlingDays = 1) {
      const now = new Date();
    
      // Convert to EST (New York)
      const estTime = new Date(
        new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).format(now)
      );
    
      console.log("estTime",estTime)
      let shippingStartDate = new Date(estTime);
  
      // If after 2PM EST, shift start day to next day
      if (estTime.getHours() >= 14) {
        shippingStartDate.setDate(shippingStartDate.getDate() + 1);
      }
    
      // Skip to next business day if it's weekend
      while (shippingStartDate.getDay() === 0 || shippingStartDate.getDay() === 6) {
        shippingStartDate.setDate(shippingStartDate.getDate() + 1);
      }
    
      // Add handling days, skipping weekends
      let daysAdded = 0;
      while (daysAdded < handlingDays) {
        shippingStartDate.setDate(shippingStartDate.getDate() + 1);
        const day = shippingStartDate.getDay();
        if (day !== 0 && day !== 6) {
          daysAdded++;
        }
      }
    
      // Format date
      const weekday = shippingStartDate.toLocaleDateString('en-US', { weekday: 'long' });
    const monthDay = shippingStartDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    return { weekday, monthDay };
    } 
    
  });
  